export const MENSAJE_TIPO_PREGUNTA = 1
export const MENSAJE_TIPO_RESPUESTA = 2
export const MENSAJE_TIPO_COMPRA_A = 3
export const MENSAJE_TIPO_COMPRA_B = 4
export const MENSAJE_TIPO_PRESUPUESTO = 7
export const MENSAJE_TIPO_MONTOS_A = 8
export const MENSAJE_TIPO_MONTOS_B = 9
export const MENSAJE_TIPO_PUBLICACION_VENCIDA = 10
export const MENSAJE_TIPO_CARGA_MASIVA = 11
export const MENSAJE_TIPO_PEDIDO_COMPRA = 12
export const MENSAJE_TIPO_PEDIDO_VENTA = 13
export const MENSAJE_TIPO_TIENDA_OFICIAL = 14
export const MENSAJE_TIPO_DEVOLUCION = 16
export const MENSAJE_TIPO_CANCELACION = 17
